import {Component, EventEmitter, Output} from '@angular/core';
import {AuthProviderEnum} from "../enum/auth-provider-enum";
import {BloomsightService} from "../../bloomsight.service";

@Component({
	selector: 'fb-auth-methods',
	templateUrl: './auth-methods.component.html',
	styleUrls: ['./auth-methods.component.scss']
})
export class AuthMethodsComponent {

	@Output()
	public authProvider: EventEmitter<AuthProviderEnum> = new EventEmitter<AuthProviderEnum>();

	constructor(
		private _bloomsight: BloomsightService
	) {
	}

	public getAuthProvider(provider: AuthProviderEnum): void {
		this.authProvider.emit(
			provider
		);

		if (provider === AuthProviderEnum.GOOGLE) {
			this._bloomsight.trackSimpleEvent('65c1eb77135d102e63e44544', '');
		} else if (provider === AuthProviderEnum.BASIC) {
			this._bloomsight.trackSimpleEvent('65c1eb89135d102e63e44552', '');
		}
	}

	protected readonly AuthProviderEnum = AuthProviderEnum;
}
